import { call, put, takeLatest } from "redux-saga/effects";
import {
GET_ROLE,
ADD_ROLE,
UPDATE_ROLE,
DELETE_ROLE,
GET_ROLE_SUCCESS,
ADD_ROLE_SECCESS,
UPDATE_ROLE_SUCCESS,
DELETE_ROLE_SUCCESS
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function getRoleApi()  {
    // api for get review list
   const response = api.dbRole().GetRoleList();
    return response;
  }
  function addRoleApi(formData) {
    // api for add  review.
    api.dbRole().AddEditRole(formData);
  }
  function updateRoleApi(formData) {
    // api for update  review.
    api.dbRole().AddEditRole(formData);
  }
  function deleteRoleApi(delId) {
    // api for delete  review.
    const response = api.dbRole().DeleteRole(delId);
    return response;
  }
  
export function* handleGetRole() {
    try {
      const response = yield call(getRoleApi);
      yield put({ type: GET_ROLE_SUCCESS, payload: response.data });
    } catch (error) {
       
    }
  }
  export function* handleAddRole({ payload }) {
    try {
      yield call(addRoleApi, payload);
      yield put({ type: ADD_ROLE_SECCESS, payload: payload });
      const response = yield call(getRoleApi);
      yield put({ type: GET_ROLE_SUCCESS, payload: response.data });
    } catch (error) {
       
    }
  }
  export function* handleUpdateRole({ payload }) {
    try {
      let formData = payload;
      yield call(updateRoleApi, formData);
      yield put({ type: UPDATE_ROLE_SUCCESS, payload: formData });
    } catch (error) {
       
    }
  }
  export function* handleDeleteRole({ payload }) {
    try {
      yield call(deleteRoleApi, payload);
      yield put({ type: DELETE_ROLE_SUCCESS, payload: payload });
    } catch (error) {
       
    }
  }
  
  // watach function.
  export function* RoleWatchFun() {
    yield takeLatest(GET_ROLE, handleGetRole);
    yield takeLatest(ADD_ROLE, handleAddRole);
    yield takeLatest(UPDATE_ROLE, handleUpdateRole);
    yield takeLatest(DELETE_ROLE, handleDeleteRole);
  }